'use client';

import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

import { useFileUploadContext } from './file-upload';

type FileUploadTriggerProps = React.ComponentProps<'button'>;

const FileUploadTrigger = ({ className, type = 'button', children, ...props }: FileUploadTriggerProps) => {
  const { openFilePicker, disabled } = useFileUploadContext();

  return (
    <button
      data-slot="file-upload-trigger"
      type={type}
      disabled={disabled}
      onClick={openFilePicker}
      className={cn(
        'inline-flex cursor-pointer flex-col items-center gap-2 text-muted-foreground transition-colors hover:text-foreground',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export { FileUploadTrigger };
